import { randomNumber } from '@/lib/random';
import { useEffect, useState } from 'react';

const randoms = [20, 40, 60, 80, 95];
function getMax(value: number) {
    return value * 0.9;
}
function getOptions(value: number): number {
    for (let i = 0; i < randoms.length; i++) {
        if (value < getMax(randoms[i])) {
            return randomNumber(value, randoms[i]);
        }
    }
    return randoms[randoms.length - 1];
}

export function useProgressing(loading: boolean) {
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        let interval: NodeJS.Timeout | null = null;
        let timeout: NodeJS.Timeout | null = null;
        if (loading) {
            interval = setInterval(
                () => {
                    setProgress(getOptions);
                },
                randomNumber(500, 1000)
            );
        } else {
            setProgress((state) => {
                if (state === 0) {
                    return state;
                }

                timeout = setTimeout(() => {
                    setProgress(0);
                }, 200);

                return 100;
            });
        }

        return () => {
            if (interval) clearInterval(interval);
            if (timeout) clearTimeout(timeout);
        };
    }, [loading]);

    return {
        progress,
        setProgress,
    };
}
